<template>
  <!--
    WHAT — Metric Insight detail tab "Placement". Configures where an insight
      lives: its parent metric (record.metric, from context.metrics), its
      per-metric insight_id, and the active flag.

    CONTRACT — reads record.metric / record.insight_id / record.is_active.
      Emits patch({ metric, insight_id, is_active }) on change. Deliberately
      owns record-level scalars ONLY — layout width + display_order travel with
      viz_config and are patched by the Visualization tab (InsightVizSection),
      not here.

    NOTES — hydrating guard: local fields seeded in data(), emit() no-ops until
      $nextTick(mounted) clears `hydrating`. Plain inputs, no wrapped v1 panel.
      Not selfChrome — ArtifactDetail wraps this in the standard titled card.
  -->
  <!-- Metric Insight "Placement" — parent metric, insight id, active. Width +
       display order live in the Visualization section's layout (they travel with
       viz_config), so this owns the record-level scalar fields only. -->
  <div class="grid grid-cols-3 gap-3">
    <div>
      <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-400 mb-1">Parent Metric</label>
      <select v-model="metric" class="w-full text-xs px-2 py-1.5 border border-gray-200 rounded-lg focus:outline-none focus:border-blue-400" @change="emit">
        <option :value="null">None</option>
        <option v-for="m in metrics" :key="m.id" :value="m.id">{{ m.name }} ({{ m.id }})</option>
      </select>
    </div>
    <div>
      <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-400 mb-1">Insight ID</label>
      <input v-model.number="insightId" type="number" class="w-full text-xs px-2 py-1.5 border border-gray-200 rounded-lg focus:outline-none focus:border-blue-400" @input="emit" />
    </div>
    <div class="flex items-end">
      <label class="flex items-center gap-2 text-xs text-gray-600">
        <input v-model="isActive" type="checkbox" class="rounded" @change="emit" /> Active
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightPlacementSection',
  props: {
    record: { type: Object, required: true },
    artifact: { type: Object, required: true },
    context: { type: Object, default: () => ({}) },
  },
  emits: ['patch'],
  data() {
    return {
      metric: this.record.metric ?? null,
      insightId: this.record.insight_id ?? 0,
      isActive: this.record.is_active !== false,
      hydrating: true,
    };
  },
  computed: {
    metrics() { return this.context.metrics || []; },
  },
  mounted() { this.$nextTick(() => { this.hydrating = false; }); },
  methods: {
    emit() {
      if (this.hydrating) return;
      this.$emit('patch', { metric: this.metric, insight_id: this.insightId, is_active: this.isActive });
    },
  },
};
</script>
